module.exports = __webpack_public_path__ + "files/96e4e62b1c14bbc3d7da4c3c34647c1a.png";